function sliderMain() {
    new Swiper(".main__slider .mySwiper",{
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
            el: ".main__slider .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            360: {
                slidesPerView: 2,
            }
        }
    })
}

function sliderMain2() {
    new Swiper(".main__slider2 .mySwiper",{
        slidesPerView: "auto",
        spaceBetween: 20,
        slideToClickedSlide: 'true',
        pagination: {
            el: ".main__slider2 .swiper-pagination",
        },
        breakpoints: {
            320: {
                spaceBetween: 15,
            },
            577: {
                spaceBetween: 20,
            }
        }
    })
}

let SlidersArray = []
function sliderWorks() {
    $(".works__slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.works__slider[data-slider-id="${index}"] .mySwiper`, {
            slidesPerView: 2,
            spaceBetween: 15,
            allowTouchMove: false,
            pagination: {
                el: `.works__slider[data-slider-id="${index}"] .works-pagination`,
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    allowTouchMove: true,
                },
                360: {
                    slidesPerView: 2,
                    allowTouchMove: true,
                },
                768: {
                    allowTouchMove: false,
                },
            }
        })
    })
}

let SlidersArray2 = []
function sliderWorkCard() {
    $(".work-card__slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray2[index] = new Swiper(`.work-card__slider[data-slider-id="${index}"] .mySwiper2`, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: `.work-card__slider[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.work-card__slider[data-slider-id="${index}"] .swiper-button-prev`,
            },
            pagination: {
                el: `.work-card__slider[data-slider-id="${index}"] .swiper-pagination`,
                clickable: true,
            },
        })
    })
}

function sliderPopular() {
    new Swiper(".popular .mySwiper",{
        slidesPerView: 3,
        spaceBetween: 15,
        pagination: {
            el: ".popular .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
            },
            360: {
                slidesPerView: 3,
            }
        }
    })
}

let SlidersArray3 = []
function sliderPoster() {
    $(".poster__slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray3[index] = new Swiper(`.poster__slider[data-slider-id="${index}"] .mySwiper`, {
            slidesPerView: 2,
            spaceBetween: 10,
            allowTouchMove: false,
            pagination: {
                el: `.poster__slider[data-slider-id="${index}"] .swiper-pagination`,
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    allowTouchMove: true,
                },
                360: {
                    slidesPerView: 2,
                    allowTouchMove: true,
                },
                768: {
                    allowTouchMove: false,
                },
            }
        })
    })
}

function sliderArt() {
    new Swiper(".art .mySwiper",{
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
            el: ".art .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            360: {
                slidesPerView: 2,
            }
        }
    })
}

function sliderCatalogThemes() {
    var swiper = new Swiper('.catalog__themes .mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        slideToClickedSlide: 'true',
        breakpoints: {
            320: {
                spaceBetween: 10,
            },
            993: {
                spaceBetween: 15,
            }
        }
    })
}

function sliderRecent() {
    new Swiper(".recent .mySwiper",{
        slidesPerView: 5,
        spaceBetween: 16,
        pagination: {
            el: ".recent-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            360: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1101: {
                slidesPerView: 4,
            },
            1301: {
                slidesPerView: 5,
            }
        }
    })
}

function sliderProfile() {
    var swiper = new Swiper('.profile__item-slider .mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        slideToClickedSlide: 'true',
    })
}

function sliderprofileSelects() {
    var swiper = new Swiper('.profile__selects .mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        slideToClickedSlide: 'true',
        breakpoints: {
            320: {
                spaceBetween: 10,
            },
            577: {
                spaceBetween: 15,
            }
        }
    })
}

function gallery() {
    var swiper = new Swiper(".gallery .mySwiper", {
        slidesPerView: 5,
        spaceBetween: 15,
        freeMode: true,
        watchSlidesProgress: true,
        direction: "horizontal",
    });
    var swiper2 = new Swiper(".gallery .mySwiper2", {
        spaceBetween: 15,
        slidesPerView: 1,
        thumbs: {
            swiper: swiper,
        },
        pagination: {
            el: ".gallery .swiper-pagination",
            clickable: true,
        },
    });
}

let SlidersArray4 = []
function sliderWorks3() {
    $(".works3").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray4[index] = new Swiper(`.works3[data-slider-id="${index}"] .mySwiper`, {
            slidesPerView: 5,
            spaceBetween: 16,
            pagination: {
                el: `.works3[data-slider-id="${index}"] .works3-pagination`,
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                360: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                993: {
                    slidesPerView: 4,
                },
                1301: {
                    slidesPerView: 5,
                }
            }
        })
    })
}

$(document).ready(function () {
    sliderMain();
    sliderMain2();
    sliderWorks();
    sliderWorkCard()
    sliderPopular();
    sliderArt();
    sliderPoster();
    sliderCatalogThemes();
    sliderRecent();
    sliderProfile();
    sliderprofileSelects();
    gallery();
    sliderWorks3()

    // Select
    $(".custom_select select").niceSelect()

    //
    $('.select__list-default').click(function () {
        $(this).parent('.select__wrap').toggleClass('select__wrap--active')
    })

    $('.select__list .li').click(function () {
        var currentele = $(this).html()
        $(this).parents('.select__wrap').find('.select__current').html(currentele)
        $(this).parents('.select__wrap').removeClass('select__wrap--active')
        $(this).siblings(".select__list .li").removeClass("li--active")
        $(this).addClass("li--active")
    })

    let selectLi = $('.select__list .li')
    let selectWrap = $('.select__wrap')

    $(document).click(function (e) {
        if ( !selectLi.is(e.target) && selectLi.has(e.target).length === 0 &&
            !selectWrap.is(e.target) && selectWrap.has(e.target).length === 0

        ) {
            selectWrap.removeClass('select__wrap--active')
        }
    })

    $('.nice-select .list li').click(function () {
        $(this).parents('.nice-select').addClass('nice-select--active')
    })

    // Catalog
    $('.header__catalog-show').click(function () {
        $(this).find('.catalog-burger').toggleClass('catalog-burger--active')
        $('.header__catalog-hidden').toggleClass('header__catalog-hidden--active')
        $('.header__catalog-bg').toggleClass('bg--active')
        $('.catalog-sidebar').removeClass('catalog-sidebar--active')
        $('.header').removeClass('fixed-header')
        $('body').toggleClass('fixed-body')
        if (window.matchMedia("(max-width: 992px)").matches) {
            $('body').addClass('fixed-body')
        }
    })

    let burger = $('.burger')
    let catalogShow = $('.header__catalog-show')
    let catalogHidden = $('.header__catalog-hidden')

    $(document).click(function (e) {
        if ( !catalogShow.is(e.target) && catalogShow.has(e.target).length === 0 &&
            !burger.is(e.target) && burger.has(e.target).length === 0 &&
            !catalogHidden.is(e.target) && catalogHidden.has(e.target).length === 0

        ) {
            catalogHidden.removeClass('header__catalog-hidden--active')
            $('.catalog-burger').removeClass('catalog-burger--active')
            $('.header__catalog-bg').removeClass('bg--active')
            $('body').removeClass('fixed-body')
        }
    })

    $('.header__catalog-close').click(function () {
        $('.catalog-burger').removeClass('catalog-burger--active')
        $('.header__catalog-hidden').removeClass('header__catalog-hidden--active')
        $('body').removeClass('fixed-body')
    })

        $('.burger').click(function () {
            $('.header__catalog-hidden').toggleClass('header__catalog-hidden--active')
            $('.catalog-sidebar').removeClass('catalog-sidebar--active')
            $('body').addClass('fixed-body')
        })

    // Search
    $('.search-mob__btn').click(function () {
        $(this).toggleClass('search-mob__btn--active')
        $('.search-mob').toggleClass('search-mob--active')
    })

    // Accordion
    $(".item-show").click((function(){
        $(this).toggleClass("item-show--active")
        $(this).siblings(".item-hidden").slideToggle()
    }));

    // Favorite
    $('.work-card__favorite').click(function () {
        $(this).toggleClass('work-card__favorite--active')
    })

    $('.favorite').click(function () {
        $(this).toggleClass('favorite--active')
    })

    // Tabs
    $(".tab").hover(function () {
        let path = $(this).attr("data-tab-path")
        $(this).siblings(".tab").removeClass("tab--active")
        $(this).addClass("tab--active")

        $(this).parents(".tabs-inner").find(".tab__content").removeClass("tab__content--active")
        $(this).parents(".tabs-inner").find(`.tab__content[data-content-path="${path}"]`).addClass("tab__content--active")
    })

    $(".tab2").click(function () {
        let path = $(this).attr("data-tab2-path")
        $(this).siblings(".tab2").removeClass("tab2--active")
        $(this).addClass("tab2--active")

        $(this).parents(".tabs-inner").find(".tab__content2").removeClass("tab__content2--active")
        $(this).parents(".tabs-inner").find(`.tab__content2[data-content2-path="${path}"]`).addClass("tab__content2--active")
    })

    // Hover slider
    $(".hover__tab").mouseover(function() {
        let path = $(this).attr("data-tab-path")
        $(this).parents(".hover__slide").find(".hover__tab").removeClass("hover__tab--active")
        $(this).addClass("hover__tab--active")
        $(this).parents(".hover__slide").find(".hover__content").removeClass("hover__content--active")
        $(this).parents(`.hover__slide`).find(`.hover__content[data-tab-path="${path}"]`).addClass("hover__content--active")
    })

    // Filter
    $('.filter-btn').click(function () {
        $('.catalog-sidebar').addClass('catalog-sidebar--active')
        $('.header').addClass('fixed-header')
        $('body').addClass('fixed-body')
    })

    $('.catalog-sidebar__close').click(function () {
        $('.catalog-sidebar').removeClass('catalog-sidebar--active')
        $('.header').removeClass('fixed-header')
        $('body').removeClass('fixed-body')
    })

    // Theme
    $('.remove-theme').click(function () {
        $(this).parents('.catalog__theme').css('display','none')
    })

    // More
    $('.show-more').click(function () {
        $(this).toggleClass('show-more--active')
        $(this).siblings('.text-overflow').toggleClass('text-overflow--active')
        $('.product-main__list').toggleClass('product-main__list--active')
    })

    $('.show-more__title').click(function () {
        $(this).toggleClass('show-more__title--active')
        $(this).parents('.show-title').toggleClass('show-title--active')
    })

    // Simple-rating
    $('.simple-rating').click(function () {
        $(this).siblings('.work-card__feedback2').addClass('work-card__feedback2--active')
        $(this).siblings('.work-card__btn2').remove()
        $(this).remove()
    })

    $('.work-card__btn2').click(function () {
        $(this).siblings('.simple-rating').addClass('simple-rating--active')
    })

    // Height - text
    $(document).ready(function() {
        $('.product-main__title').each(function() {
            if ($(this).height() > 42) {
                $(this).addClass('show-title');
            } else {
                $(this).removeClass('show-title');
            }
        });
    });

    $(document).ready(function() {
        $('.feedback-card__text').each(function() {
            if ($(this).height() > 160) {
                $(this).parents('.feedback-card').addClass('feedback-card--height');
            }
        });
    });

    // Password
    $('.password-btn').click(function () {
        if ($(this).siblings('.password-input').attr('type') == 'password') {
            $(this).addClass('password-btn--active');
            $(this).siblings('.password-input').attr('type', 'text');
        } else {
            $(this).removeClass('password-btn--active');
            $(this).siblings('.password-input').attr('type', 'password');
        }
    })

    // Promocode
    $('.promocode__btn').click(function () {
        $('.promocode__activated').addClass('promocode__activated--active')
        $(this).parents('.promocode').remove()
    })

    // Calc
    function cartCalc(){
        $('.cartcalc .ccalc-minus').click(function(){
            let a = $(this).closest('.cartcalc').find('input').val();
            if(a>1){
                let b = +a-1;
                $(this).closest('.cartcalc').find('input').val(b);
            }else{
                $(this).closest('.cartcalc').find('input').val(a);
            }
        });
        $('.cartcalc .ccalc-plus').click(function(){
            let a = $(this).closest('.cartcalc').find('input').val();
            let b = +a+1;
            $(this).closest('.cartcalc').find('input').val(b);
        });
    }
    cartCalc()

    // Basket
   $('.basket__check').click(function () {
        var $basketCardChecks = $(this).parents('.basket__group').find('.basket-card__check');

        if ($(this).hasClass('basket__check--active')) {
            $basketCardChecks.removeClass('basket-card__check--active');
            $basketCardChecks.each(function() {
            if (!$(this).hasClass('basket-card__check--active')) {
                $(this).parents('.basket-card').removeClass('basket-card--active');
            }
        });
        $(this).removeClass('basket__check--active');
        } else {
            $(this).addClass('basket__check--active');
            $basketCardChecks.addClass('basket-card__check--active');
            $basketCardChecks.each(function() {
            $(this).parents('.basket-card').addClass('basket-card--active');
        });
    }
    });

    $('.basket-card__check').click(function () {
        $(this).toggleClass('basket-card__check--active');
        $(this).parents('.basket-card').toggleClass('basket-card--active')
        if ($(this).parents('.basket__group').find('.basket-card__check.basket-card__check--active').length === 0) {
            $(this).parents('.basket__group').find('.basket__check').removeClass('basket__check--active');
        }
    });



    $('.basket-address__btn').click(function () {
        $(this).parents('.basket__group').addClass('remove-group')
        $(this).parents('.basket__group').siblings('.basket__group').addClass('add-group')
        $(this).parents('.basket__group').siblings('.basket__group--new').addClass('remove-group')
        $('.basket__btns').addClass('basket__btns--active')
    })

    $('.cancel').click(function () {
        $(this).parents('.basket__btns').removeClass('basket__btns--active')
        $('.basket__group--form').removeClass('add-group')
        $('.basket__group--address').removeClass('remove-group')
    })

    $('.form-check input[type="radio"][name="form-check"]').change(function() {
    const $closestGroup = $(this).closest('.basket__group--form');

    if ($closestGroup.hasClass('checked-group')) {
        $closestGroup.removeClass('checked-group');
    } else {
        $('.basket__group--form').removeClass('checked-group');
        $closestGroup.addClass('checked-group');
    }
});
    $('.new-address__add').click(function () {
        $(this).parents('.basket__group--form').removeClass('remove-group')
        $(this).parents('.basket__group--form').next('.basket__group--form').addClass('add-group')
        $(this).addClass('new-address__add--remove')
    })

    $('.new-address__delete').click(function () {
        $(this).parents('.basket__group--form').removeClass('add-group')
        $(this).parents('.basket__group--form').addClass('remove-group')
        $(this).parents('.basket__group--form').prev('.basket__group--form').find('.new-address__add').removeClass('new-address__add--remove')
    })

    $('.basket-card__delete').click(function () {
        var $parents = $(this).parents('.basket-card');
        if ($parents.hasClass('basket-card--active')) {
            $parents.addClass('basket-card--remove');
        }
    })

    $('.basket__delete').click(function () {
        var $activeCards = $('.basket-card.basket-card--active');
        if ($activeCards.length > 0) {
            $activeCards.addClass('basket-card--remove');
        }
    });

    $(".form-check input").on("click", function (e) {
        console.clear(); console.log(this.checked); // всегда true;
        e.preventDefault();
  
        setTimeout(
            () => $(this).prop("checked", !this.checked).trigger("change")
        );
    });

    // User
    $('.user__show').click(function () {
        $(this).siblings('.user__hidden').toggleClass('user__hidden--active')
    })

    $('.user__close').click(function () {
        $('.user__hidden').removeClass('user__hidden--active')
    })

    let userShow = $('.user__show')
    let userHidden = $('.user__hidden')

    $(document).click(function (e) {
        if ( !userShow.is(e.target) && userShow.has(e.target).length === 0 &&
            !userHidden.is(e.target) && userHidden.has(e.target).length === 0

        ) {
            userHidden.removeClass('user__hidden--active')
        }
    })

    $('.nice-select .list li').click(function () {
        $(this).parents('.nice-select').addClass('nice-select--active')
    })

    // Modal
    $("[data-modal]").click(function () {
        let modalId = $(this).attr("data-modal")

        openModal(modalId)
    })

    function openModal(modalId){
        $(`#${modalId}`).addClass("modal--active")
        $("body").addClass("fixed-body2")
    }

    $(".modal").click(function () {
        closeModal()
    })

    $("._close-modal").click(function () {
        closeModal()
    })

    $(".modal__dialog").click(function (e) {
        e.stopPropagation()
    })


    function closeModal() {
        $('.modal').removeClass("modal--active")
        $("body").removeClass("fixed-body2")
    }

    // Add-basket
    $('.product-main__btn').click(function () {
        $(this).addClass('product-main__btn--active');
        setTimeout(() => {
            $(this).removeClass('product-main__btn--active');
        },2000);
    })

})
